var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "img-view",
    on: {
      "click": _vm.bigImg
    }
  }, [_c('div', {
    staticClass: "img-layer"
  }), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc
    }
  })])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };